import styled, { DefaultTheme } from "styled-components";
import { typographyCSS } from "@ifgengineering/design-tokens/legacy";

export type V3ChartSeries = 1 | 2 | 3 | 4;

const seriesColor = (theme: DefaultTheme, series: V3ChartSeries): string => {
  const chart = theme.colors.chart;
  switch (series) {
    case 1:
      return chart.series1;
    case 2:
      return chart.series2;
    case 3:
      return chart.series3;
    default:
      return chart.series4;
  }
};

export const ProportionBarWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.sm}px;
  width: 100%;
`;

export const ProportionBarTrack = styled.div<{ $height: number }>`
  display: flex;
  gap: ${({ theme }) => theme.space["3xs"]}px;
  width: 100%;
  height: ${({ $height }) => $height}px;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radius.full}px;
  background: ${({ theme }) => theme.colors.ui.background.inset};
`;

export const ProportionBarSegment = styled.span<{
  $series: V3ChartSeries;
  $percentage: number;
}>`
  flex: 0 0 ${({ $percentage }) => $percentage}%;
  background: ${({ theme, $series }) => seriesColor(theme, $series)};
`;

export const ProportionBarLegend = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.space.md}px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ProportionBarLegendItem = styled.li`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.sm}px;
  ${typographyCSS("caption.sm")}
  color: ${({ theme }) => theme.colors.ui.text.secondary};
`;

export const ProportionBarLegendDot = styled.span<{ $series: V3ChartSeries }>`
  flex: none;
  width: ${({ theme }) => theme.size.indicator.pagination.dot}px;
  height: ${({ theme }) => theme.size.indicator.pagination.dot}px;
  border-radius: ${({ theme }) => theme.radius.full}px;
  background: ${({ theme, $series }) => seriesColor(theme, $series)};
`;
